import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { IBrand, IBrandProps, IBrandStates } from "./interfaces";

export class Brand extends EntityManager<IBrand, IBrandProps, IBrandStates>{
    static initMetadata = (): IMetadata => {
        return {
            name: "Brand",
            title: "برند",
            Properties: [
                {
                    title: "نام",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام برند را وارد نمایید' }]
                },
                {
                    title: "کد",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 100,
                    rules: [{ required: true, message: 'لطفا کد را وارد نمایید' }],
                    showInLookup: false
                },
                {
                    title: "توضیحات",
                    dataIndex: "Description",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 100,
                    showInLookup: false
                }
            ]
        };
    };
}